import { localizedRoute } from 'Pods/Shared/paths'

// GenerateListingPageUrl always returns English listing paths; swap them for the translated
// route segments before pushing a canonical URL into history on a localized page.
function localizeBackendUrl(url, locale) {
  if (!locale || locale === 'en' || !url) return url

  const localModels = localizedRoute({ key: 'models', locale })
  const localPrintModels = localizedRoute({ key: 'print-models', locale })
  const localFreeModels = localizedRoute({ key: 'free-models', locale })
  const localFreePrintModels = localizedRoute({ key: 'free-print-models', locale })

  return url
    .replace(/\/free-3d-print-models/g, localFreePrintModels)
    .replace(/\/free-3d-models/g, localFreeModels)
    .replace(/\/3d-print-models/g, localPrintModels)
    .replace(/\/3d-models/g, localModels)
}

export default localizeBackendUrl
